import { ArrowUpDown } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu.tsx";
import { DataTableCenteredCell } from "@/shared/ui/DataTable";
import { Button } from "@/shared/ui/button.tsx";
import { StatusInfo } from "@/widgets/StatusInfo";
import { HoverCardInfo } from "@/features/HoverCardInfo";
import { useURLParamsData } from "@/shared/hooks/useURLParamsData.ts";
import { localizationMap } from "@/shared/lib/consts";
import { useSessionStore } from "@/entities/session";
import { Roles } from "@/entities/user";
import { LeadStatus } from "@/entities/lead-v2";

type StatusOption = {
  value: LeadStatus | null;
  label: string;
};

const statusOptions: StatusOption[] = [
  { value: null, label: "Все статусы" },
  // { value: LeadStatus.SPINNING, label: "Крутит" },
  { value: LeadStatus.IGNORE, label: "Игнорит" },
  { value: LeadStatus.DEPOSIT, label: "Дэп" },
  { value: LeadStatus.HAD_CALL, label: "Был звонок" },
  { value: LeadStatus.REJECTED, label: "Отклонен" },
  { value: LeadStatus.TEXTED, label: "Отписал" },
  { value: LeadStatus.LOOKING_FOR_DEPOSIT, label: "В поисках депозита" },
];

const additionalOptions: StatusOption[] = [
  { value: LeadStatus.FRESH, label: "Без куратора" },
  { value: LeadStatus.WARMING_UP, label: "Прогрев" },
  {
    value: LeadStatus.SURVEY_IN_PROGRESS,
    label: "Проходит опрос (в процессе)",
  },
  { value: LeadStatus.SURVEY_COMPLETED, label: "Прошел опрос" },
  { value: LeadStatus.REMOVED_BY_SURVEY, label: "Опрос не пройден" },
  { value: LeadStatus.UNLINKED, label: "Отвязан" },
];

export const StatusModal = () => {
  const { leadStatus, setLeadStatus } = useURLParamsData();
  const { user } = useSessionStore();

  const options: StatusOption[] = [
    ...statusOptions,
    ...([Roles.Worker, Roles.Head, Roles.Moderator].includes(user?.role!)
      ? additionalOptions
      : []),
  ];

  return (
    <DropdownMenu>
      <DataTableCenteredCell className="flex flex-row">
        <DropdownMenuTrigger asChild>
          <Button variant="ghost">
            <p className="text-thColor">
              {leadStatus
                ? localizationMap[leadStatus] || leadStatus
                : "Статус"}
            </p>
            <ArrowUpDown className="ml-2 h-4 w-4 text-thColor" />
          </Button>
        </DropdownMenuTrigger>
        <StatusInfo />
      </DataTableCenteredCell>
      <DropdownMenuContent>
        {options.map(({ value, label }) => (
          <DropdownMenuItem
            key={value}
            className="overflow-y-auto"
            onClick={() => setLeadStatus(value)}
          >
            {value ? (
              <HoverCardInfo text={label}>{label}</HoverCardInfo>
            ) : (
              label
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
